/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';

import { filter, map, switchMap } from 'rxjs';

import { NbDateService } from '@nebular/theme';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';

import { LANGUAGE_LOCAL_STORAGE_KEY } from '@app/config';
import { LANGUAGE_CODE } from '@app/shared/models/localization-lang';
import { LocalizationService } from '@app/shared/services/localization.service';
import { navigationActions } from '@app/store/actions/navigation.actions';
import { translateActions } from '@app/store/actions/translate.actions';

@Injectable()
export class TranslateEffects {
  public readonly changeLanguage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(translateActions.setLanguage),
      switchMap(action => {
        localStorage.setItem(LANGUAGE_LOCAL_STORAGE_KEY, action.language);
        if (action.language === LANGUAGE_CODE.TESTING_LANGUAGE_CODE) {
          this.translateService.setFallbackLang(action.language);
        }
        this.localizationService.registerLocale(action.language);
        this.nebularDateService.setLocale(action.language);
        return this.translateService.use(action.language).pipe(map(() => action));
      }),
      filter(({ skipPageReload }) => !skipPageReload),
      map(() => navigationActions.reloadCurrentRoute()),
    ),
  );

  constructor(
    private actions$: Actions,
    private translateService: TranslateService,
    private localizationService: LocalizationService,
    private nebularDateService: NbDateService<unknown>,
  ) {}
}
